import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Drawer, Input, Field } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const Edit = ({ factor, onClose, onSave, show }) => {
  const [data, setData] = useState({
    id: null,
    carrier_id: null,
    data_version_id: null,
    name: '',
    annual_factor: '1.0',
    semi_annual_factor: '0.5',
    quarterly_factor: '0.25',
    monthly_factor: '0.083'
  });
  const [errors, setErrors] = useState([]);
  const [save_error, setSaveError] = useState(false);

  useEffect(() => {
    const new_factor = factor || {};

    setData({
      id: new_factor.id,
      carrier_id: new_factor.carrier_id,
      data_version_id: new_factor.data_version_id,
      name: new_factor.name || '',
      annual_factor: new_factor.annual_factor || '1.0',
      semi_annual_factor: new_factor.semi_annual_factor || '0.5',
      quarterly_factor: new_factor.quarterly_factor || '0.25',
      monthly_factor: new_factor.monthly_factor || '0.083'
    });
  }, [factor]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      const { id, ...payload } = data;

      Api.saveModalFactor(id, payload)
        .then(() => {
          onSave();
          setSaveError(false);
        })
        .catch(() => {
          setSaveError(true);
          setTimeout(() => {
            setSaveError(false);
          }, 2000);
        });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>{data.id ? 'Save Changes' : 'Create Modal Factor'}</Button>
      }
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Modal Factor' : 'New Modal Factor'}
    >
      {save_error ? (
        <Alert type='error'>An error occurred while trying to save the modal factor.</Alert>
      ) : null}

      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          required={true}
          value={data.name}
        />
      </Field>

      <Field label='Annual'>
        <Input
          onChange={handleInputChange.bind(null, 'annual_factor')}
          required={true}
          type='number'
          value={data.annual_factor}
        />
      </Field>

      <Field label='Semi-Annual'>
        <Input
          onChange={handleInputChange.bind(null, 'semi_annual_factor')}
          required={true}
          type='number'
          value={data.semi_annual_factor}
        />
      </Field>

      <Field label='Quarterly'>
        <Input
          onChange={handleInputChange.bind(null, 'quarterly_factor')}
          required={true}
          type='number'
          value={data.quarterly_factor}
        />
      </Field>

      <Field label='Monthly'>
        <Input
          onChange={handleInputChange.bind(null, 'monthly_factor')}
          required={true}
          type='number'
          value={data.monthly_factor}
        />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  factor: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default Edit;
